import { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";

export default function FooterSection() {
  const [privacyOpen, setPrivacyOpen] = useState(false);

  return (
    <footer className="border-t border-white/5 pb-12 pt-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p
          data-testid="footer-brand-logo"
          className="text-outline select-none text-center text-[16vw] font-extrabold leading-none tracking-tight lg:text-[10rem]"
        >
          FITNANCE
        </p>

        <div className="mt-14 flex flex-col items-center justify-between gap-8 border-t border-white/5 pt-10 md:flex-row">
          <div className="text-center md:text-left">
            <p className="font-mono text-sm font-bold tracking-[0.25em] text-slate-50">
              FITNANCE<span className="text-emerald-400">.</span>APP
            </p>
            <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">
              Live on the App Store · Google Play soon
            </p>
          </div>

          <div className="flex items-center gap-8 font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-400">
            <button
              data-testid="footer-privacy-modal-trigger"
              onClick={() => setPrivacyOpen(true)}
              className="transition-colors duration-300 hover:text-emerald-400"
            >
              Privacy
            </button>
            <button
              data-testid="footer-support-link"
              onClick={() => document.getElementById("support")?.scrollIntoView({ behavior: "smooth" })}
              className="transition-colors duration-300 hover:text-emerald-400"
            >
              Support
            </button>
            <Link to="/admin" data-testid="footer-admin-link" className="transition-colors duration-300 hover:text-emerald-400">
              Admin
            </Link>
          </div>
        </div>

        <p className="mt-10 text-center font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-700">
          © 2026 Fitnance.app — All rights reserved
        </p>
      </div>

      <AnimatePresence>
        {privacyOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[70] flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm"
            onClick={() => setPrivacyOpen(false)}
          >
            <motion.div
              initial={{ opacity: 0, y: 24, scale: 0.97 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 24, scale: 0.97 }}
              transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
              onClick={(e) => e.stopPropagation()}
              className="relative w-full max-w-md rounded-3xl border border-white/10 bg-[#111318] p-8"
            >
              <button
                data-testid="privacy-modal-close-button"
                onClick={() => setPrivacyOpen(false)}
                className="absolute right-5 top-5 text-neutral-500 transition-colors hover:text-slate-100"
                aria-label="Close"
              >
                <X className="h-5 w-5" />
              </button>
              <h3 className="text-lg font-bold text-slate-50">Privacy, in plain words</h3>
              <p className="mt-4 text-sm leading-relaxed text-neutral-300">
                Joining the waitlist stores only your email address so we can
                notify you when Fitnance launches in September 2026. No tracking,
                no third-party sharing, no spam — one launch email, then product
                updates you can leave anytime.
              </p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </footer>
  );
}
